const PAGE_PREFIX = "page_workstation_maintain";

const common = [
  "readonly",
  "readwrite",
  "yes",
  "no",
  "first_step",
  "second_step",
  "third_step",
  "fourth_step",
  "delete_tips",
  "create_success",
  "delete_success",
  "modify_success",
  "save_success",
  "ok",
  "copy",
  "save",
  "cancel",
  "create",
  "actions",
  "delete",
  "placeholder",
  "search",
  "edit"
];

const _proxy = {};

const getLang = (context, prefix = PAGE_PREFIX): any =>
  new Proxy(_proxy, {
    get: (obj, prop: any) => {
      try {
        return context.$t(`${common.includes(prop) ? "" : prefix+"_"}${prop}`);
      } catch (err) {}
    },
  });

export default getLang;
